// 保存七、八、九年级每个星级对应的评价和分数
// 七、八年级星级对应的分数
const seven_star_score = {
    // 词汇运用
    word_score:[
        [
            {
                value: 0,
                label: 0
            }
        ],
        [
            {
                value: 1,
                label: 1
            },
            {
                value: 2,
                label: 2
            },
            {
                value: 3,
                label: 3
            },
            {
                value: 4,
                label: 4
            },
            {
                value: 5,
                label: 5
            }
        ],
        [
            {
                value: 6,
                label: 6
            },
            {
                value: 7,
                label: 7
            },
            {
                value: 8,
                label: 8
            },
            {
                value: 9,
                label: 9
            },
            {
                value: 10,
                label: 10
            }
        ],
        [
            {
                value: 11,
                label: 11
            },
            {
                value: 12,
                label: 12
            },
            {
                value: 13,
                label: 13
            },
            {
                value: 14,
                label: 14
            },
            {
                value: 15,
                label: 15
            }
        ],
        [
            {
                value: 16,
                label: 16
            },
            {
                value: 17,
                label: 17
            },
            {
                value: 18,
                label: 18
            },
            {
                value: 19,
                label: 19
            },
            {
                value: 20,
                label: 20
            }
        ],
        [
            {
                value: 21,
                label: 21
            },
            {
                value: 22,
                label: 22
            },
            {
                value: 23,
                label: 23
            },
            {
                value: 24,
                label: 24
            },
            {
                value: 25,
                label: 25
            }
        ]
    ],
    // 语言表达
    expression_score:[
        [
            {
                value: 0,
                label: 0
            }
        ],
        [
            {
                value: 1,
                label: 1
            },
            {
                value: 2,
                label: 2
            },
            {
                value: 3,
                label: 3
            },
            {
                value: 4,
                label: 4
            },
            {
                value: 5,
                label: 5
            },
            {
                value: 6,
                label: 6
            },
            {
                value: 7,
                label: 7
            }
        ],
        [
            {
                value: 8,
                label: 8
            },
            {
                value: 9,
                label: 9
            },
            {
                value: 10,
                label: 10
            },
            {
                value: 11,
                label: 11
            },
            {
                value: 12,
                label: 12
            },
            {
                value: 13,
                label: 13
            },
            {
                value: 14,
                label: 14
            }
        ],
        [
            {
                value: 15,
                label: 15
            },
            {
                value: 16,
                label: 16
            },
            {
                value: 17,
                label: 17
            },
            {
                value: 18,
                label: 18
            },
            {
                value: 19,
                label: 19
            },
            {
                value: 20,
                label: 20
            },
            {
                value: 21,
                label: 21
            }
        ],
        [
            {
                value: 22,
                label: 22
            },
            {
                value: 23,
                label: 23
            },
            {
                value: 24,
                label: 24
            },
            {
                value: 25,
                label: 25
            },
            {
                value: 26,
                label: 26
            },
            {
                value: 27,
                label: 27
            },
            {
                value: 28,
                label: 28
            }
        ],
        [
            {
                value: 29,
                label: 29
            },
            {
                value: 30,
                label: 30
            },
            {
                value: 31,
                label: 31
            },
            {
                value: 32,
                label: 32
            },
            {
                value: 33,
                label: 33
            },
            {
                value: 34,
                label: 34
            },
            {
                value: 35,
                label: 35
            }
        ]
    ],
    // 篇章结构
    structure_score:[
        [
            {
                value: 0,
                label: 0
            }
        ],
        [
            {
                value: 1,
                label: 1
            },
            {
                value: 2,
                label: 2
            },
            {
                value: 3,
                label: 3
            },
            {
                value: 4,
                label: 4
            },
            {
                value: 5,
                label: 5
            },
            {
                value: 6,
                label: 6
            },
            {
                value: 7,
                label: 7
            },
            {
                value: 8,
                label: 8
            }
        ],
        [
            {
                value: 9,
                label: 9
            },
            {
                value: 10,
                label: 10
            },
            {
                value: 11,
                label: 11
            },
            {
                value: 12,
                label: 12
            },
            {
                value: 13,
                label: 13
            },
            {
                value: 14,
                label: 14
            },
            {
                value: 15,
                label: 15
            },
            {
                value: 16,
                label: 16
            }
        ],
        [
            {
                value: 17,
                label: 17
            },
            {
                value: 18,
                label: 18
            },
            {
                value: 19,
                label: 19
            },
            {
                value: 20,
                label: 20
            },
            {
                value: 21,
                label: 21
            },
            {
                value: 22,
                label: 22
            },
            {
                value: 23,
                label: 23
            },
            {
                value: 24,
                label: 24
            }
        ],
        [
            {
                value: 25,
                label: 25
            },
            {
                value: 26,
                label: 26
            },
            {
                value: 27,
                label: 27
            },
            {
                value: 28,
                label: 28
            },
            {
                value: 29,
                label: 29
            },
            {
                value: 30,
                label: 30
            },
            {
                value: 31,
                label: 31
            },
            {
                value: 32,
                label: 32
            }
        ],
        [
            {
                value: 33,
                label: 33
            },
            {
                value: 34,
                label: 34
            },
            {
                value: 35,
                label: 35
            },
            {
                value: 36,
                label: 36
            },
            {
                value: 37,
                label: 37
            },
            {
                value: 38,
                label: 38
            },
            {
                value: 39,
                label: 39
            },
            {
                value: 40,
                label: 40
            }
        ]
    ]
};
// 九年级星级对应的分数
const nine_star_score = {
    // 词汇运用
    word_score:[
        [
            {
                value: 0,
                label: 0
            }
        ],
        [
            {
                value: 1,
                label: 1
            },
            {
                value: 2,
                label: 2
            },
            {
                value: 3,
                label: 3
            },
            {
                value: 4,
                label: 4
            }
        ],
        [
            {
                value: 5,
                label: 5
            },
            {
                value: 6,
                label: 6
            },
            {
                value: 7,
                label: 7
            },
            {
                value: 8,
                label: 8
            }
        ],
        [
            {
                value: 9,
                label: 9
            },
            {
                value: 10,
                label: 10
            },
            {
                value: 11,
                label: 11
            },
            {
                value: 12,
                label: 12
            }
        ],
        [
            {
                value: 13,
                label: 13
            },
            {
                value: 14,
                label: 14
            },
            {
                value: 15,
                label: 15
            },
            {
                value: 16,
                label: 16
            }
        ],
        [
            {
                value: 17,
                label: 17
            },
            {
                value: 18,
                label: 18
            },
            {
                value: 19,
                label: 19
            },
            {
                value: 20,
                label: 20
            }
        ]
    ],
    // 语言表达
    expression_score:[
        [
            {
                value: 0,
                label: 0
            }
        ],
        [
            {
                value: 1,
                label: 1
            },
            {
                value: 2,
                label: 2
            },
            {
                value: 3,
                label: 3
            },
            {
                value: 4,
                label: 4
            },
            {
                value: 5,
                label: 5
            },
            {
                value: 6,
                label: 6
            }
        ],
        [
            {
                value: 7,
                label: 7
            },
            {
                value: 8,
                label: 8
            },
            {
                value: 9,
                label: 9
            },
            {
                value: 10,
                label: 10
            },
            {
                value: 11,
                label: 11
            },
            {
                value: 12,
                label: 12
            }
        ],
        [
            {
                value: 13,
                label: 13
            },
            {
                value: 14,
                label: 14
            },
            {
                value: 15,
                label: 15
            },
            {
                value: 16,
                label: 16
            },
            {
                value: 17,
                label: 17
            },
            {
                value: 18,
                label: 18
            }
        ],
        [
            {
                value: 19,
                label: 19
            },
            {
                value: 20,
                label: 20
            },
            {
                value: 21,
                label: 21
            },
            {
                value: 22,
                label: 22
            },
            {
                value: 23,
                label: 23
            },
            {
                value: 24,
                label: 24
            }
        ],
        [
            {
                value: 25,
                label: 25
            },
            {
                value: 26,
                label: 26
            },
            {
                value: 27,
                label: 27
            },
            {
                value: 28,
                label: 28
            },
            {
                value: 29,
                label: 29
            },
            {
                value: 30,
                label: 30
            }
        ]
    ],
    // 篇章结构
    structure_score:[
        [
            {
                value: 0,
                label: 0
            }
        ],
        [
            {
                value: 1,
                label: 1
            },
            {
                value: 2,
                label: 2
            },
            {
                value: 3,
                label: 3
            },
            {
                value: 4,
                label: 4
            },
            {
                value: 5,
                label: 5
            },
            {
                value: 6,
                label: 6
            },
            {
                value: 7,
                label: 7
            },
            {
                value: 8,
                label: 8
            },
            {
                value: 9,
                label: 9
            },
            {
                value: 10,
                label: 10
            }
        ],
        [
            {
                value: 11,
                label: 11
            },
            {
                value: 12,
                label: 12
            },
            {
                value: 13,
                label: 13
            },
            {
                value: 14,
                label: 14
            },
            {
                value: 15,
                label: 15
            },
            {
                value: 16,
                label: 16
            },
            {
                value: 17,
                label: 17
            },
            {
                value: 18,
                label: 18
            },
            {
                value: 19,
                label: 19
            },
            {
                value: 20,
                label: 20
            }
        ],
        [
            {
                value: 21,
                label: 21
            },
            {
                value: 22,
                label: 22
            },
            {
                value: 23,
                label: 23
            },
            {
                value: 24,
                label: 24
            },
            {
                value: 25,
                label: 25
            },
            {
                value: 26,
                label: 26
            },
            {
                value: 27,
                label: 27
            },
            {
                value: 28,
                label: 28
            },
            {
                value: 29,
                label: 29
            },
            {
                value: 30,
                label: 30
            }
        ],
        [
            {
                value: 31,
                label: 31
            },
            {
                value: 32,
                label: 32
            },
            {
                value: 33,
                label: 33
            },
            {
                value: 34,
                label: 34
            },
            {
                value: 35,
                label: 35
            },
            {
                value: 36,
                label: 36
            },
            {
                value: 37,
                label: 37
            },
            {
                value: 38,
                label: 38
            },
            {
                value: 39,
                label: 39
            },
            {
                value: 40,
                label: 40
            }
        ],
        [
            {
                value: 41,
                label: 41
            },
            {
                value: 42,
                label: 42
            },
            {
                value: 43,
                label: 43
            },
            {
                value: 44,
                label: 44
            },
            {
                value: 45,
                label: 45
            },
            {
                value: 46,
                label: 46
            },
            {
                value: 47,
                label: 47
            },
            {
                value: 48,
                label: 48
            },
            {
                value: 49,
                label: 49
            },
            {
                value: 50,
                label: 50
            }
        ]
    ]
};
// 高中作文星级对应的分数
const high_school_score = {
    // 语言 / 要点
    word_score: [
        [
            {
                value: 0,
                label: 0
            }
        ],
        [
            {
                value: 1,
                label: 1
            },
            {
                value: 2,
                label: 2
            },
            {
                value: 3,
                label: 3
            },
            {
                value: 4,
                label: 4
            },
            {
                value: 5,
                label: 5
            },
            {
                value: 6,
                label: 6
            },
            {
                value: 7,
                label: 7
            },
            {
                value: 8,
                label: 8
            }
        ],
        [
            {
                value: 9,
                label: 9
            },
            {
                value: 10,
                label: 10
            },
            {
                value: 11,
                label: 11
            },
            {
                value: 12,
                label: 12
            },
            {
                value: 13,
                label: 13
            },
            {
                value: 14,
                label: 14
            },
            {
                value: 15,
                label: 15
            },
            {
                value: 16,
                label: 16
            }
        ],
        [
            {
                value: 17,
                label: 17
            },
            {
                value: 18,
                label: 18
            },
            {
                value: 19,
                label: 19
            },
            {
                value: 20,
                label: 20
            },
            {
                value: 21,
                label: 21
            },
            {
                value: 22,
                label: 22
            },
            {
                value: 23,
                label: 23
            },
            {
                value: 24,
                label: 24
            }
        ],
        [
            {
                value: 25,
                label: 25
            },
            {
                value: 26,
                label: 26
            },
            {
                value: 27,
                label: 27
            },
            {
                value: 28,
                label: 28
            },
            {
                value: 29,
                label: 29
            },
            {
                value: 30,
                label: 30
            },
            {
                value: 31,
                label: 31
            },
            {
                value: 32,
                label: 32
            }
        ],
        [
            {
                value: 33,
                label: 33
            },
            {
                value: 34,
                label: 34
            },
            {
                value: 35,
                label: 35
            },
            {
                value: 36,
                label: 36
            },
            {
                value: 37,
                label: 37
            },
            {
                value: 38,
                label: 38
            },
            {
                value: 39,
                label: 39
            },
            {
                value: 40,
                label: 40
            }
        ]
    ],
    // 内容 / 语言
    expression_score: [
        [
            {
                value: 0,
                label: 0
            }
        ],
        [
            {
                value: 1,
                label: 1
            },
            {
                value: 2,
                label: 2
            },
            {
                value: 3,
                label: 3
            },
            {
                value: 4,
                label: 4
            },
            {
                value: 5,
                label: 5
            },
            {
                value: 6,
                label: 6
            },
            {
                value: 7,
                label: 7
            },
            {
                value: 8,
                label: 8
            }
        ],
        [
            {
                value: 9,
                label: 9
            },
            {
                value: 10,
                label: 10
            },
            {
                value: 11,
                label: 11
            },
            {
                value: 12,
                label: 12
            },
            {
                value: 13,
                label: 13
            },
            {
                value: 14,
                label: 14
            },
            {
                value: 15,
                label: 15
            },
            {
                value: 16,
                label: 16
            }
        ],
        [
            {
                value: 17,
                label: 17
            },
            {
                value: 18,
                label: 18
            },
            {
                value: 19,
                label: 19
            },
            {
                value: 20,
                label: 20
            },
            {
                value: 21,
                label: 21
            },
            {
                value: 22,
                label: 22
            },
            {
                value: 23,
                label: 23
            },
            {
                value: 24,
                label: 24
            }
        ],
        [
            {
                value: 25,
                label: 25
            },
            {
                value: 26,
                label: 26
            },
            {
                value: 27,
                label: 27
            },
            {
                value: 28,
                label: 28
            },
            {
                value: 29,
                label: 29
            },
            {
                value: 30,
                label: 30
            },
            {
                value: 31,
                label: 31
            },
            {
                value: 32,
                label: 32
            }
        ],
        [
            {
                value: 33,
                label: 33
            },
            {
                value: 34,
                label: 34
            },
            {
                value: 35,
                label: 35
            },
            {
                value: 36,
                label: 36
            },
            {
                value: 37,
                label: 37
            },
            {
                value: 38,
                label: 38
            },
            {
                value: 39,
                label: 39
            },
            {
                value: 40,
                label: 40
            }
        ]
    ],
    // 结构 / 连贯性
    structure_score: [
        [
            {
                value: 0,
                label: 0
            }
        ],
        [
            {
                value: 1,
                label: 1
            },
            {
                value: 2,
                label: 2
            },
            {
                value: 3,
                label: 3
            },
            {
                value: 4,
                label: 4
            }
        ],
        [
            {
                value: 5,
                label: 5
            },
            {
                value: 6,
                label: 6
            },
            {
                value: 7,
                label: 7
            },
            {
                value: 8,
                label: 8
            }
        ],
        [
            {
                value: 9,
                label: 9
            },
            {
                value: 10,
                label: 10
            },
            {
                value: 11,
                label: 11
            },
            {
                value: 12,
                label: 12
            }
        ],
        [
            {
                value: 13,
                label: 13
            },
            {
                value: 14,
                label: 14
            },
            {
                value: 15,
                label: 15
            },
            {
                value: 16,
                label: 16
            }
        ],
        [
            {
                value: 17,
                label: 17
            },
            {
                value: 18,
                label: 18
            },
            {
                value: 19,
                label: 19
            },
            {
                value: 20,
                label: 20
            }
        ]
    ]
};
// 初中作文以及高中‘应用文’作文对应的评语列表
const basic_comments = {
    // 第一维度
    word_evaluate:[
        [
            {
                value: '所写内容几乎没有完整的单词',
                label: '所写内容几乎没有完整的单词'
            }, 
            {
                value: '所用有效词汇太少，无法评价',
                label: '所用有效词汇太少，无法评价'
            }, 
            {
                value: '所写内容是汉语拼音',
                label: '所写内容是汉语拼音'
            }
        ],
        [
            {
                value: '学生对词汇的理解不到位，表达的意思含糊，需加强词汇的掌握与使用',
                label: '学生对词汇的理解不到位，表达的意思含糊，需加强词汇的掌握与使用'
            }, 
            {
                value: '学生用词太过单一，词汇知识贫乏，要加强词汇量的积累',
                label: '学生用词太过单一，词汇知识贫乏，要加强词汇量的积累'
            }, 
            {
                value: '只写出若干与话题相关的单词，未满足文章要求',
                label: '只写出若干与话题相关的单词，未满足文章要求'
            }, 
            {
                value: '文章中未见使用顺序词和衔接词',
                label: '文章中未见使用顺序词和衔接词'
            }, 
            {
                value: '有大量词汇错误，包含用词错误和拼写错误，影响意思表达，几乎难以读懂',
                label: '有大量词汇错误，包含用词错误和拼写错误，影响意思表达，几乎难以读懂'
            }, 
            {
                value: '文章中词性错误很多，记忆含糊，张冠李戴的情况也很多',
                label: '文章中词性错误很多，记忆含糊，张冠李戴的情况也很多'
            }, 
            {
                value: '学生词汇基础薄弱，词汇运用能力亟待加强',
                label: '学生词汇基础薄弱，词汇运用能力亟待加强'
            }, 
            {
                value: '受中文标点影响，英文标点使用有误',
                label: '受中文标点影响，英文标点使用有误'
            }, 
            {
                value: '书写不够清晰，影响单词辨识',
                label: '书写不够清晰，影响单词辨识'
            }
        ],
        [
            {
                value: '学生词汇较为匮乏，总体词汇使用不丰富',
                label: '学生词汇较为匮乏，总体词汇使用不丰富'
            }, 
            {
                value: '词汇使用不准确，错误较多，影响了对写作内容的理解',
                label: '词汇使用不准确，错误较多，影响了对写作内容的理解'
            }, 
            {
                value: '学生词汇运用能力有限',
                label: '学生词汇运用能力有限'
            }, 
            {
                value: '大小写和标点错误较多',
                label: '大小写和标点错误较多'
            }, 
            {
                value: '单词拼写错误过多，望继续努力',
                label: '单词拼写错误过多，望继续努力'
            }, 
            {
                value: '文中使用了不雅观词汇，请加以检查并选择合适的用词',
                label: '文中使用了不雅观词汇，请加以检查并选择合适的用词'
            }, 
            {
                value: '文章中基本没有过渡词和衔接词，建议增加衔接词汇的积累，并尝试运用',
                label: '文章中基本没有过渡词和衔接词，建议增加衔接词汇的积累，并尝试运用'
            }
        ],
        [
            {
                value: '词汇表达较简单，希望学生可以尝试使用新学到的词，加强词汇表达的多样性',
                label: '词汇表达较简单，希望学生可以尝试使用新学到的词，加强词汇表达的多样性'
            }, 
            {
                value: '文章中重复使用的词汇略多，用词缺乏变化，词汇量提升空间较大',
                label: '文章中重复使用的词汇略多，用词缺乏变化，词汇量提升空间较大'
            }, 
            {
                value: '文章中使用了一些高级词汇',
                label: '文章中使用了一些高级词汇'
            }, 
            {
                value: '文章中有一些词汇错误，但尚能达意',
                label: '文章中有一些词汇错误，但尚能达意'
            }, 
            {
                value: '文章中有部分大小写和标点错误',
                label: '文章中有部分大小写和标点错误'
            }, 
            {
                value: '请增加高级词汇的使用',
                label: '请增加高级词汇的使用'
            }, 
            {
                value: '文章中有部分拼写错误',
                label: '文章中有部分拼写错误'
            }, 
            {
                value: '可适当增加衔接词，建议使用一些过程性词汇',
                label: '可适当增加衔接词，建议使用一些过程性词汇'
            }
        ],
        [
            {
                value: '文章词汇表达较丰富，能较好地使用中高档的词汇、短语、成语等',
                label: '文章词汇表达较丰富，能较好地使用中高档的词汇、短语、成语等'
            },
            {
                value: '学生词汇基础不错，但有少量拼写错误',
                label: '学生词汇基础不错，但有少量拼写错误'
            }, 
            {
                value: '词汇运用较自然流畅，拼写较准确',
                label: '词汇运用较自然流畅，拼写较准确'
            }, 
            {
                value: '词汇应用基本准确，有些错误主要是尝试使用较复杂的词汇和表达方式所致',
                label: '词汇应用基本准确，有些错误主要是尝试使用较复杂的词汇和表达方式所致'
            }, 
            {
                value: '学生具备较强的词汇运用能力，应用的词汇能满足任务要求',
                label: '学生具备较强的词汇运用能力，应用的词汇能满足任务要求'
            }, 
            {
                value: '大小写及标点运用基本得当，有少量错误',
                label: '大小写及标点运用基本得当，有少量错误'
            }, 
            {
                value: '顺序词和连接词使用得不错',
                label: '顺序词和连接词使用得不错'
            }
        ],
        [
            {
                value: '学生词汇基本功很好，高级词汇表达灵活熟练，单词拼写正确',
                label: '学生词汇基本功很好，高级词汇表达灵活熟练，单词拼写正确'
            }, 
            {
                value: '学生词汇表达灵活多变，固定搭配、句型和成语使用恰当',
                label: '学生词汇表达灵活多变，固定搭配、句型和成语使用恰当'
            },
            {
                value: '学生具备很强的词汇运用能力，同义词、上下义词、反义词的使用和替换熟练',
                label: '学生具备很强的词汇运用能力，同义词、上下义词、反义词的使用和替换熟练'
            }, 
            {
                value: '用词适切地道，单词拼写、大小写、标点符号使用正确',
                label: '用词适切地道，单词拼写、大小写、标点符号使用正确'
            },
            {
                value: '基本词汇使用恰当灵活，文中存在个别标点错误',
                label: '基本词汇使用恰当灵活，文中存在个别标点错误'
            }, 
            {
                value: '文章词汇表达丰富，对词汇的理解准确，运用恰当',
                label: '文章词汇表达丰富，对词汇的理解准确，运用恰当'
            },
            {
                value: '文中介词、冠词、连词等虚词使用准确，形容词和副词的使用恰当，顺序词、衔接词等路标词使用恰到好处',
                label: '文中介词、冠词、连词等虚词使用准确，形容词和副词的使用恰当，顺序词、衔接词等路标词使用恰到好处'
            }, 
            {
                value: '文章词汇使用满足任务要求，有少量由于使用复杂结构而引起的表达错误，但基本不影响理解',
                label: '文章词汇使用满足任务要求，有少量由于使用复杂结构而引起的表达错误，但基本不影响理解'
            },
            {
                value: '文中使用了很多积极正面的词汇，增强了文章的感情色彩和可读性',
                label: '文中使用了很多积极正面的词汇，增强了文章的感情色彩和可读性'
            }
        ]
    ],
    // 第二维度
    expression_evaluate:[
        [
            {
                value: '所写内容与题目要求无关',
                label: '所写内容与题目要求无关'
            }, 
            {
                value: '内容与要求无关或无法辨认',
                label: '内容与要求无关或无法辨认'
            },
            {
                value: '所传达的信息太少，无法评价',
                label: '所传达的信息太少，无法评价'
            }
        ],
        [
            {
                value: '语法错误过多，影响意思的表达',
                label: '语法错误过多，影响意思的表达'
            }, 
            {
                value: '只使用了简单句，且出现了大量的语法错误',
                label: '只使用了简单句，且出现了大量的语法错误'
            },
            {
                value: '意思表达含糊不清，大量中式表达',
                label: '意思表达含糊不清，大量中式表达'
            }, 
            {
                value: '整体表达混乱',
                label: '整体表达混乱'
            },
            {
                value: '正确句子比例极低',
                label: '正确句子比例极低'
            }, 
            {
                value: '不成句，句法表达碎片化',
                label: '不成句，句法表达碎片化'
            },
            {
                value: '表达不通顺，存在大量的句法错误',
                label: '表达不通顺，存在大量的句法错误'
            }, 
            {
                value: '时态混乱，语义表达不明',
                label: '时态混乱，语义表达不明'
            },
            {
                value: '语法基础薄弱，句子结构过于单一且有较多错误',
                label: '语法基础薄弱，句子结构过于单一且有较多错误'
            }
        ],
        [
            {
                value: '只有少量正确句子，意思表达不明确',
                label: '只有少量正确句子，意思表达不明确'
            }, 
            {
                value: '无句式变化，简单句的使用存在较多错误',
                label: '无句式变化，简单句的使用存在较多错误'
            },
            {
                value: '语义表达较单一，中式表达较明显',
                label: '语义表达较单一，中式表达较明显'
            }, 
            {
                value: '部分简单句的表达中存在明显错误',
                label: '部分简单句的表达中存在明显错误'
            },
            {
                value: '句法基础不够扎实，部分句子的表达碎片化',
                label: '句法基础不够扎实，部分句子的表达碎片化'
            },
            {
                value: '部分句子结构混乱，存在语义含糊的问题',
                label: '部分句子结构混乱，存在语义含糊的问题'
            }, 
            {
                value: '错误句子较多，从句使用不熟练',
                label: '错误句子较多，从句使用不熟练'
            },
            {
                value: '语法基础不扎实，部分句子时态人称混乱',
                label: '语法基础不扎实，部分句子时态人称混乱'
            },
            {
                value: '语句不通顺，存在较多语法错误',
                label: '语句不通顺，存在较多语法错误'
            }
        ],
        [
            {
                value: '从句比例偏低，需加强长难句的使用',
                label: '从句比例偏低，需加强长难句的使用'
            }, 
            {
                value: '正确句子数量较多，部分复杂句的表达存在语法错误',
                label: '正确句子数量较多，部分复杂句的表达存在语法错误'
            },
            {
                value: '有一定的语法功底，但部分表达语义不明',
                label: '有一定的语法功底，但部分表达语义不明'
            },
            {
                value: '简单句数量偏多，存在部分语法错误',
                label: '简单句数量偏多，存在部分语法错误'
            }, 
            {
                value: '语句基本通顺，有一些语法错误',
                label: '语句基本通顺，有一些语法错误'
            },
            {
                value: '使用了简单的从句，但部分从句存在明显的错误',
                label: '使用了简单的从句，但部分从句存在明显的错误'
            },
            {
                value: '句式表达单一，可适当增加复杂句的使用让表达多样化',
                label: '句式表达单一，可适当增加复杂句的使用让表达多样化'
            }, 
            {
                value: '语义较明确，但存在部分中式表达',
                label: '语义较明确，但存在部分中式表达'
            },
            {
                value: '个别句子结构混乱，语义表达碎片化',
                label: '个别句子结构混乱，语义表达碎片化'
            }, 
            {
                value: '有一定的句法基础，可以加强复杂句的使用',
                label: '有一定的句法基础，可以加强复杂句的使用'
            },
            {
                value: '通篇都是简单句，可适当增加从句的使用为文章增加亮点',
                label: '通篇都是简单句，可适当增加从句的使用为文章增加亮点'
            }, 
            {
                value: '部分句子表达累赘，可适当精简结构使语义更清晰',
                label: '部分句子表达累赘，可适当精简结构使语义更清晰'
            }
        ],
        [
            {
                value: '句式变化较多样，个别句子存在小错误',
                label: '句式变化较多样，个别句子存在小错误'
            }, 
            {
                value: '句子错误很少，个别复杂句使用不够熟练',
                label: '句子错误很少，个别复杂句使用不够熟练'
            },
            {
                value: '语法基础较扎实，但个别表达较为中式',
                label: '语法基础较扎实，但个别表达较为中式'
            },
            {
                value: '句法比较规范，但长难句的使用偏少',
                label: '句法比较规范，但长难句的使用偏少'
            }, 
            {
                value: '长短句搭配合理，存在个别表达含糊的情况',
                label: '长短句搭配合理，存在个别表达含糊的情况'
            },
            {
                value: '句式变化较明显，部分简单从句转为复杂的长难句会让文章更出彩',
                label: '句式变化较明显，部分简单从句转为复杂的长难句会让文章更出彩'
            },
            {
                value: '语句较流畅，可适当增加长难句的使用',
                label: '语句较流畅，可适当增加长难句的使用'
            }, 
            {
                value: '正确使用了简单的从句，可适当增加复杂从句的使用',
                label: '正确使用了简单的从句，可适当增加复杂从句的使用'
            },
            {
                value: '部分简单长句用得很好，可适当增加从句的使用',
                label: '部分简单长句用得很好，可适当增加从句的使用'
            }, 
            {
                value: '有意识地使用了复杂句式，但表达中存在小错误',
                label: '有意识地使用了复杂句式，但表达中存在小错误'
            }
        ],
        [
            {
                value: '句子表达准确流畅，能够很好地使用长难句',
                label: '句子表达准确流畅，能够很好地使用长难句'
            }, 
            {
                value: '句法知识扎实，有效地使用了从句为文章增色',
                label: '句法知识扎实，有效地使用了从句为文章增色'
            },
            {
                value: '内容表达地道，语法规范',
                label: '内容表达地道，语法规范'
            },
            {
                value: '语法规范，熟练正确地使用了长难句',
                label: '语法规范，熟练正确地使用了长难句'
            }, 
            {
                value: '句式变化明显，长难句与简单句比例得当',
                label: '句式变化明显，长难句与简单句比例得当'
            },
            {
                value: '语法规范，句子表达准确',
                label: '语法规范，句子表达准确'
            },
            {
                value: '有意识地使用了谚语让表达更生动',
                label: '有意识地使用了谚语让表达更生动'
            }, 
            {
                value: '语法功底很棒，句子使用灵活多样',
                label: '语法功底很棒，句子使用灵活多样'
            },
            {
                value: '语法规范，修辞的使用让文章更生动',
                label: '语法规范，修辞的使用让文章更生动'
            }, 
            {
                value: '句式变化多样，谚语的使用是点睛之笔',
                label: '句式变化多样，谚语的使用是点睛之笔'
            }
        ]
    ],
    // 第三维度
    structure_evaluate:[
        [
            {
                value: '所写内容与题目要求无关',
                label: '所写内容与题目要求无关'
            }
        ],
        [
            {
                value: '只写出个别词语',
                label: '只写出个别词语'
            }, 
            {
                value: '要点信息严重不足',
                label: '要点信息严重不足'
            },
            {
                value: '写出个别要点，文章结构混乱',
                label: '写出个别要点，文章结构混乱'
            },
            {
                value: '多数语句不完整或意思不明，无法传达有效信息',
                label: '多数语句不完整或意思不明，无法传达有效信息'
            }, 
            {
                value: '写出少量要点，缺少过渡词和衔接词',
                label: '写出少量要点，缺少过渡词和衔接词'
            },
            {
                value: '字数严重不足，上下文衔接不流畅',
                label: '字数严重不足，上下文衔接不流畅'
            },
            {
                value: '文章严重走题，没有包括所提供的信息内容',
                label: '文章严重走题，没有包括所提供的信息内容'
            }, 
            {
                value: '整体人称使用错误',
                label: '整体人称使用错误'
            },
            {
                value: '整体时态使用错误',
                label: '整体时态使用错误'
            }
        ],
        [
            {
                value: '要点不够全面',
                label: '要点不够全面'
            }, 
            {
                value: '全文有少量过渡词，但存在重复使用的现象',
                label: '全文有少量过渡词，但存在重复使用的现象'
            },
            {
                value: '行文流畅，但是字数不达标',
                label: '行文流畅，但是字数不达标'
            },
            {
                value: '字数严重超标，废话太多',
                label: '字数严重超标，废话太多'
            }, 
            {
                value: '文章内容没有条理性',
                label: '文章内容没有条理性'
            },
            {
                value: '文章结构不严谨，行文不流畅',
                label: '文章结构不严谨，行文不流畅'
            },
            {
                value: '叙述简略粗糙，人物缺乏鲜明的个性特征',
                label: '叙述简略粗糙，人物缺乏鲜明的个性特征'
            }, 
            {
                value: '文章不够连贯，影响对写作内容的理解',
                label: '文章不够连贯，影响对写作内容的理解'
            },
            {
                value: '没能准确地表达自己的观点',
                label: '没能准确地表达自己的观点'
            }, 
            {
                value: '部分内容时态使用错误',
                label: '部分内容时态使用错误'
            }
        ],
        [
            {
                value: '要点全面，但没有详略，如同记流水账',
                label: '要点全面，但没有详略，如同记流水账'
            }, 
            {
                value: '要点全面，但重点内容不够突出',
                label: '要点全面，但重点内容不够突出'
            },
            {
                value: '要点基本全面，能正确使用少量过渡词',
                label: '要点基本全面，能正确使用少量过渡词'
            },
            {
                value: '要点基本全面，但整体内容不够完整',
                label: '要点基本全面，但整体内容不够完整'
            }, 
            {
                value: '采用了适当的衔接手法，层次清晰，但是字数不达标',
                label: '采用了适当的衔接手法，层次清晰，但是字数不达标'
            },
            {
                value: '行文流畅度欠缺，应增加文中衔接词的使用',
                label: '行文流畅度欠缺，应增加文中衔接词的使用'
            },
            {
                value: '文章层次清晰分明，但是文中很少使用过渡词和衔接词',
                label: '文章层次清晰分明，但是文中很少使用过渡词和衔接词'
            }, 
            {
                value: '文中所举例子过于陈旧，不能打动人',
                label: '文中所举例子过于陈旧，不能打动人'
            },
            {
                value: '仅仅对文章的要点进行了翻译',
                label: '仅仅对文章的要点进行了翻译'
            }, 
            {
                value: '存在个别前后逻辑错误',
                label: '存在个别前后逻辑错误'
            }
        ],
        [
            {
                value: '要点全面，内容连贯性比较好，结构也比较紧凑',
                label: '要点全面，内容连贯性比较好，结构也比较紧凑'
            }, 
            {
                value: '文章结构不错，使用了丰富的衔接词和过渡词，但是字数超标较为严重',
                label: '文章结构不错，使用了丰富的衔接词和过渡词，但是字数超标较为严重'
            },
            {
                value: '对所给要点进行了巧妙的重组，自由发挥部分的内容可以再丰富些',
                label: '对所给要点进行了巧妙的重组，自由发挥部分的内容可以再丰富些'
            },
            {
                value: '可以比较清晰地、层次分明地表达出自己想表达的意思',
                label: '可以比较清晰地、层次分明地表达出自己想表达的意思'
            }, 
            {
                value: '论述缺少中心句，只陈述了理由',
                label: '论述缺少中心句，只陈述了理由'
            },
            {
                value: '对问题的分析很到位，但是解决措施写得较为笼统',
                label: '对问题的分析很到位，但是解决措施写得较为笼统'
            },
            {
                value: '对图片（表格）呈现的信息理解较为透彻',
                label: '对图片（表格）呈现的信息理解较为透彻'
            }, 
            {
                value: '论证比较清晰、有逻辑性，但需要多用更客观的句型',
                label: '论证比较清晰、有逻辑性，但需要多用更客观的句型'
            },
            {
                value: '观点陈述清晰直观，但是缺少一个有力的总结',
                label: '观点陈述清晰直观，但是缺少一个有力的总结'
            }, 
            {
                value: '准确地表达了个人的观点，但是论述不够深刻',
                label: '准确地表达了个人的观点，但是论述不够深刻'
            }
        ],
        [
            {
                value: '要点全面，详略得当，上下文衔接自然',
                label: '要点全面，详略得当，上下文衔接自然'
            }, 
            {
                value: '内容切题，表达清楚、完整',
                label: '内容切题，表达清楚、完整'
            },
            {
                value: '叙事条理清晰，逻辑结构严谨',
                label: '叙事条理清晰，逻辑结构严谨'
            },
            {
                value: '分段布局合理，中心突出',
                label: '分段布局合理，中心突出'
            }, 
            {
                value: '对所给要点进行了巧妙的重组，而不是直接翻译，并且进行了合理的发挥',
                label: '对所给要点进行了巧妙的重组，而不是直接翻译，并且进行了合理的发挥'
            },
            {
                value: '长短句的交替使用使得文章结构紧凑且增强了文章的可读性',
                label: '长短句的交替使用使得文章结构紧凑且增强了文章的可读性'
            },
            {
                value: '内容新颖，贴近社会现实',
                label: '内容新颖，贴近社会现实'
            }, 
            {
                value: '细节描述生动，人物个性鲜明，形象丰满',
                label: '细节描述生动，人物个性鲜明，形象丰满'
            },
            {
                value: '能够综合运用多种论证方法来论证论点，论述条理清晰',
                label: '能够综合运用多种论证方法来论证论点，论述条理清晰'
            },
            {
                value: '各个论点间联系较好，论证具有说服力',
                label: '各个论点间联系较好，论证具有说服力'
            }
        ]
    ]
};
// 概要写作类型作文的评语
const summary_writing_comments = {
    // 第一维度
    word_evaluate: [
        [
            {
                value: '所写内容与题目要求无关',
                label: '所写内容与题目要求无关'
            },
            {
                value: '内容与要求无关或无法辨认',
                label: '内容与要求无关或无法辨认'
            },
            {
                value: '所传达的信息太少，无法评价',
                label: '所传达的信息太少，无法评价'
            }
        ],
        [
            {
                value: '没有理解原文，造成概要内容与原文主题不符',
                label: '没有理解原文，造成概要内容与原文主题不符'
            },
            {
                value: '只写出个别词语，要点信息严重不足',
                label: '只写出个别词语，要点信息严重不足'
            },
            {
                value: '写出个别要点，无法传达有效信息',
                label: '写出个别要点，无法传达有效信息'
            },
            {
                value: '写出少量要点，字数严重不足',
                label: '写出少量要点，字数严重不足'
            },
            {
                value: '概要内容严重偏离原文主题',
                label: '概要内容严重偏离原文主题'
            }
        ],
        [
            {
                value: '理解有误差，仅涵盖半数要点',
                label: '理解有误差，仅涵盖半数要点'
            },
            {
                value: '要点不够全面，字数不达标',
                label: '要点不够全面，字数不达标'
            },
            {
                value: '理解有误差，要点概括有失偏颇',
                label: '理解有误差，要点概括有失偏颇'
            },
            {
                value: '部分要点概述错误，影响文章整体内容准确性的呈现',
                label: '部分要点概述错误，影响文章整体内容准确性的呈现'
            },
            {
                value: '对文章理解不到位，要点概述不完整',
                label: '对文章理解不到位，要点概述不完整'
            },
            {
                value: '要点概述内容与原文贴合度不高',
                label: '要点概述内容与原文贴合度不高'
            }
        ],
        [
            {
                value: '理解较为准确，涵盖大部分要点',
                label: '理解较为准确，涵盖大部分要点'
            },
            {
                value: '要点基本全面，但整体内容不够完整',
                label: '要点基本全面，但整体内容不够完整'
            },
            {
                value: '要点基本全面，但概述内容详略不得当，字数超标',
                label: '要点基本全面，但概述内容详略不得当，字数超标'
            },
            {
                value: '对文章主题把握较准确，但个别要点不相关',
                label: '对文章主题把握较准确，但个别要点不相关'
            },
            {
                value: '要点较全面，但要点表述零散，中心内容不突出',
                label: '要点较全面，但要点表述零散，中心内容不突出'
            },
            {
                value: '对原文理解基本准确，但要点表述生硬，个别要点呈现不完整',
                label: '对原文理解基本准确，但要点表述生硬，个别要点呈现不完整'
            }
        ],
        [
            {
                value: '理解准确，涵盖绝大部分要点',
                label: '理解准确，涵盖绝大部分要点'
            },
            {
                value: '对主题的分析理解比较到位，要点较全面',
                label: '对主题的分析理解比较到位，要点较全面'
            },
            {
                value: '要点概述较全面，对主题把握较准确',
                label: '要点概述较全面，对主题把握较准确'
            },
            {
                value: '要点概述呈现较完整，字数符合题目要求',
                label: '要点概述呈现较完整，字数符合题目要求'
            },
            {
                value: '对原文概述的完成度较高，涵盖绝大部分要点',
                label: '对原文概述的完成度较高，涵盖绝大部分要点'
            },
            {
                value: '对原文主题把握清晰，总体概述表达较完整、准确',
                label: '对原文主题把握清晰，总体概述表达较完整、准确'
            }
        ],
        [
            {
                value: '文章主题提炼准确，涵盖全部要点，表达清晰',
                label: '文章主题提炼准确，涵盖全部要点，表达清晰'
            },
            {
                value: '要点全面，详略得当',
                label: '要点全面，详略得当'
            },
            {
                value: '对主题剖析准确，要点表达全面',
                label: '对主题剖析准确，要点表达全面'
            },
            {
                value: '游刃有余地概括了文章的全部要点',
                label: '游刃有余地概括了文章的全部要点'
            },
            {
                value: '文章去粗取精，要点提取准确、全面',
                label: '文章去粗取精，要点提取准确、全面'
            },
            {
                value: '要点表述全面准确，且要点排列叙述层层递进',
                label: '要点表述全面准确，且要点排列叙述层层递进'
            },
            {
                value: '对主题把握一针见血，要点叙述完整、准确',
                label: '对主题把握一针见血，要点叙述完整、准确'
            },
            {
                value: '要点提炼概括准确，完美贴合文章主题',
                label: '要点提炼概括准确，完美贴合文章主题'
            },
            {
                value: '理解准确，要点全面，并对要点进行了巧妙的重组',
                label: '理解准确，要点全面，并对要点进行了巧妙的重组'
            },
            {
                value: '要点概述全面，中心主旨概括得精准到位，巧妙流畅',
                label: '要点概述全面，中心主旨概括得精准到位，巧妙流畅'
            }
        ]
    ],
    // 第二维度
    expression_evaluate: [
        [
            {
                value: '所写内容几乎没有完整的单词',
                label: '所写内容几乎没有完整的单词'
            },
            {
                value: '所用有效词汇太少，无法评价',
                label: '所用有效词汇太少，无法评价'
            },
            {
                value: '所写内容是汉语拼音',
                label: '所写内容是汉语拼音'
            }
        ],
        [
            {
                value: '多个句子抄自原文，未使用自己的语言进行概述',
                label: '多个句子抄自原文，未使用自己的语言进行概述'
            },
            {
                value: '标点使用错误过多，影响了意思的表达',
                label: '标点使用错误过多，影响了意思的表达'
            },
            {
                value: '书写不够清晰，影响单词辨识',
                label: '书写不够清晰，影响单词辨识'
            },
            {
                value: '有较多语法结构和词汇方面的错误，严重影响了意义的表达',
                label: '有较多语法结构和词汇方面的错误，严重影响了意义的表达'
            },
            {
                value: '学生用词太过单一，词汇知识贫乏，语法错误过多，影响意思的表达',
                label: '学生用词太过单一，词汇知识贫乏，语法错误过多，影响意思的表达'
            },
            {
                value: '有大量词汇错误，包含用词错误和拼写错误，影响意思表达，几乎难以读懂',
                label: '有大量词汇错误，包含用词错误和拼写错误，影响意思表达，几乎难以读懂'
            },
            {
                value: '文章中词性错误很多，句式多为简单句，且出现了大量的语法错误，意思表达含糊不清',
                label: '文章中词性错误很多，句式多为简单句，且出现了大量的语法错误，意思表达含糊不清'
            },
            {
                value: '学生词汇基础薄弱，正确句子比例低，亟待加强词汇和语法知识',
                label: '学生词汇基础薄弱，正确句子比例低，亟待加强词汇和语法知识'
            },
            {
                value: '词汇基础薄弱，句法表达碎片化表达不通顺，存在大量的句法错误',
                label: '词汇基础薄弱，句法表达碎片化表达不通顺，存在大量的句法错误'
            },
            {
                value: '语法、词汇基础薄弱，句子结构过于单一且有较多错误',
                label: '语法、词汇基础薄弱，句子结构过于单一且有较多错误'
            }
        ],
        [
            {
                value: '有些语法结构和词汇方面的错误，影响了意义的表达',
                label: '有些语法结构和词汇方面的错误，影响了意义的表达'
            },
            {
                value: '出现两句以上整句抄自原文的现象，且错误句子较多',
                label: '出现两句以上整句抄自原文的现象，且错误句子较多'
            },
            {
                value: '大小写和标点错误较多',
                label: '大小写和标点错误较多'
            },
            {
                value: '学生词汇较为匮乏，只有少量正确句子，意思表达不明确',
                label: '学生词汇较为匮乏，只有少量正确句子，意思表达不明确'
            },
            {
                value: '总体词汇使用不丰富，无句式变化，简单句的使用存在较多错误',
                label: '总体词汇使用不丰富，无句式变化，简单句的使用存在较多错误'
            },
            {
                value: '词汇使用不准确，从句使用不熟练，语法基础不扎实，影响了对写作内容的理解',
                label: '词汇使用不准确，从句使用不熟练，语法基础不扎实，影响了对写作内容的理解'
            },
            {
                value: '学生词汇运用能力有限，部分句子的表达碎片化',
                label: '学生词汇运用能力有限，部分句子的表达碎片化'
            },
            {
                value: '词汇、句法运用存在较多错误，部分句子结构混乱，存在语义含糊的问题',
                label: '词汇、句法运用存在较多错误，部分句子结构混乱，存在语义含糊的问题'
            },
            {
                value: '存在多处拼写错误，中式表达较明显，影响了对写作内容的理解',
                label: '存在多处拼写错误，中式表达较明显，影响了对写作内容的理解'
            },
            {
                value: '部分句子时态人称混乱，语句不通顺，存在较多语法错误',
                label: '部分句子时态人称混乱，语句不通顺，存在较多语法错误'
            },
            {
                value: '存在多处词性误用，句法基础不够扎实，语言贫乏',
                label: '存在多处词性误用，句法基础不够扎实，语言贫乏'
            }
        ],
        [
            {
                value: '有两句以上整句抄自原文的现象',
                label: '有两句以上整句抄自原文的现象'
            },
            {
                value: '文章中有部分拼写和标点错误',
                label: '文章中有部分拼写和标点错误'
            },
            {
                value: '词汇表达较简单，从句比例偏低，需加强长难句的使用',
                label: '词汇表达较简单，从句比例偏低，需加强长难句的使用'
            },
            {
                value: '词汇运用缺乏多样性，简单句数量偏多，存在部分语法错误',
                label: '词汇运用缺乏多样性，简单句数量偏多，存在部分语法错误'
            },
            {
                value: '文章中重复使用的词汇略多，语句基本通顺，但有一些语法错误',
                label: '文章中重复使用的词汇略多，语句基本通顺，但有一些语法错误'
            },
            {
                value: '用词缺乏变化，句式表达单一，可适当增加高级词汇、句式的使用让表达多样化',
                label: '用词缺乏变化，句式表达单一，可适当增加高级词汇、句式的使用让表达多样化'
            },
            {
                value: '文章中有一些词汇错误，但尚能达意，语义较明确，但存在部分中式表达',
                label: '文章中有一些词汇错误，但尚能达意，语义较明确，但存在部分中式表达'
            },
            {
                value: '文章中使用了一些高级词汇，但有部分拼写错误，部分表达语义不明',
                label: '文章中使用了一些高级词汇，但有部分拼写错误，部分表达语义不明'
            },
            {
                value: '词汇表达较简单，部分复杂句的表达存在语法错误',
                label: '词汇表达较简单，部分复杂句的表达存在语法错误'
            },
            {
                value: '有一定的词汇、语法功底，但个别词汇运用不当，部分表达语义不明',
                label: '有一定的词汇、语法功底，但个别词汇运用不当，部分表达语义不明'
            },
            {
                value: '使用了简单的从句，但部分从句存在明显的错误',
                label: '使用了简单的从句，但部分从句存在明显的错误'
            },
            {
                value: '有一定的词汇、句法基础，可以加强高级词汇以及复杂句的使用',
                label: '有一定的词汇、句法基础，可以加强高级词汇以及复杂句的使用'
            },
            {
                value: '通篇都是简单词句，可适当增加从句的使用为文章增加亮点',
                label: '通篇都是简单词句，可适当增加从句的使用为文章增加亮点'
            },
            {
                value: '部分句子表达累赘，可适当精简结构使语义更清晰',
                label: '部分句子表达累赘，可适当精简结构使语义更清晰'
            }
        ],
        [
            {
                value: '有个别整句抄自原文',
                label: '有个别整句抄自原文'
            },
            {
                value: '文章词汇表达较丰富，句式变化较多样，个别句子存在小错误',
                label: '文章词汇表达较丰富，句式变化较多样，个别句子存在小错误'
            },
            {
                value: '能较好地使用中高档的词汇、短语，句子错误很少',
                label: '能较好地使用中高档的词汇、短语，句子错误很少'
            },
            {
                value: '学生词汇基础不错，语法基础较扎实，但个别表达较为中式',
                label: '学生词汇基础不错，语法基础较扎实，但个别表达较为中式'
            },
            {
                value: '学生词汇基础较好，使用了一定数量的高级词汇，但存在少量拼写错误',
                label: '学生词汇基础较好，使用了一定数量的高级词汇，但存在少量拼写错误'
            },
            {
                value: '词汇应用基本准确，句式变化较明显，部分简单从句转为复杂的长难句会让文章更出彩',
                label: '词汇应用基本准确，句式变化较明显，部分简单从句转为复杂的长难句会让文章更出彩'
            },
            {
                value: '词汇、句法比较规范，但长难句的使用偏少',
                label: '词汇、句法比较规范，但长难句的使用偏少'
            },
            {
                value: '词汇运用妥帖，长短句搭配合理，但存在个别表达含糊的情况',
                label: '词汇运用妥帖，长短句搭配合理，但存在个别表达含糊的情况'
            },
            {
                value: '有些错误主要是尝试使用较复杂的词汇和表达方式所致',
                label: '有些错误主要是尝试使用较复杂的词汇和表达方式所致'
            },
            {
                value: '词汇运用较熟练，正确使用了简单的从句，可适当增加复杂从句的使用',
                label: '词汇运用较熟练，正确使用了简单的从句，可适当增加复杂从句的使用'
            },
            {
                value: '词汇运用有些许错误，部分简单长句用得很好，语言表达完整',
                label: '词汇运用有些许错误，部分简单长句用得很好，语言表达完整'
            },
            {
                value: '有意识地使用了复杂句式以及高级词汇，但表达中存在小错误',
                label: '有意识地使用了复杂句式以及高级词汇，但表达中存在小错误'
            }
        ],
        [
            {
                value: '学生词汇运用准确，句法使用灵活，语言概括能力强',
                label: '学生词汇运用准确，句法使用灵活，语言概括能力强'
            },
            {
                value: '学生词汇基本功很好，高级词汇表达灵活熟练，单词拼写正确',
                label: '学生词汇基本功很好，高级词汇表达灵活熟练，单词拼写正确'
            },
            {
                value: '学生词汇表达灵活多变，固定搭配和句型使用恰当，有效地使用了从句为文章增色',
                label: '学生词汇表达灵活多变，固定搭配和句型使用恰当，有效地使用了从句为文章增色'
            },
            {
                value: '学生具备很强的词汇运用能力，同义词、上下义词、反义词的使用和替换熟练，熟练正确地使用了长难句',
                label: '学生具备很强的词汇运用能力，同义词、上下义词、反义词的使用和替换熟练，熟练正确地使用了长难句'
            },
            {
                value: '文章词汇表达丰富，运用恰当，高级句式的运用让人耳目一新',
                label: '文章词汇表达丰富，运用恰当，高级句式的运用让人耳目一新'
            },
            {
                value: '内容表达地道，用词精确谨慎，语法规范，所用句式难易交错',
                label: '内容表达地道，用词精确谨慎，语法规范，所用句式难易交错'
            },
            {
                value: '固定句式及地道的短语赋予了文章别样的风采',
                label: '固定句式及地道的短语赋予了文章别样的风采'
            },
            {
                value: '学生准确运用了高级词汇，语法规范，句式变化明显，长难句与简单句比例得当',
                label: '学生准确运用了高级词汇，语法规范，句式变化明显，长难句与简单句比例得当'
            },
            {
                value: '学生词汇表达准确到位，句子表达准确流畅，能够很好地使用长难句',
                label: '学生词汇表达准确到位，句子表达准确流畅，能够很好地使用长难句'
            },
            {
                value: '学生词汇运用恰当熟练，句法知识扎实，句子表达灵活、准确',
                label: '学生词汇运用恰当熟练，句法知识扎实，句子表达灵活、准确'
            },
            {
                value: '语法功底很棒，句子使用灵活多样',
                label: '语法功底很棒，句子使用灵活多样'
            },
            {
                value: '语法规范，修辞的使用让文章更生动',
                label: '语法规范，修辞的使用让文章更生动'
            },
            {
                value: '用词灵活，句式变化多样，长短句的交替使用增强了文章的可读性',
                label: '用词灵活，句式变化多样，长短句的交替使用增强了文章的可读性'
            }
        ]
    ],
    // 第三维度
    structure_evaluate: [
        [
            {
                value: '所写内容与题目要求无关',
                label: '所写内容与题目要求无关'
            }
        ],
        [
            {
                value: '缺乏语句间的连接成分，全文内容不连贯',
                label: '缺乏语句间的连接成分，全文内容不连贯'
            },
            {
                value: '缺少过渡词和衔接词，上下文衔接不流畅',
                label: '缺少过渡词和衔接词，上下文衔接不流畅'
            },
            {
                value: '各信息点之间未使用衔接词，文章生硬，没有逻辑性',
                label: '各信息点之间未使用衔接词，文章生硬，没有逻辑性'
            },
            {
                value: '句与句之间未进行有效连接，文章内容割裂，阅读观感差',
                label: '句与句之间未进行有效连接，文章内容割裂，阅读观感差'
            },
            {
                value: '文章衔接词运用错误，逻辑混乱',
                label: '文章衔接词运用错误，逻辑混乱'
            },
            {
                value: '全文毫无连贯性可言，内容杂糅，结构混乱',
                label: '全文毫无连贯性可言，内容杂糅，结构混乱'
            }
        ],
        [
            {
                value: '较少使用语句间的连接成分，全文内容缺少连贯性',
                label: '较少使用语句间的连接成分，全文内容缺少连贯性'
            },
            {
                value: '全文有少量过渡词，但存在重复使用的现象',
                label: '全文有少量过渡词，但存在重复使用的现象'
            },
            {
                value: '文章内容没有条理性',
                label: '文章内容没有条理性'
            },
            {
                value: '文章结构不严谨，行文不流畅',
                label: '文章结构不严谨，行文不流畅'
            },
            {
                value: '文章不够连贯，影响对写作内容的理解',
                label: '文章不够连贯，影响对写作内容的理解'
            }
        ],
        [
            {
                value: '应用了简单的语句间连接成分，使上下文内容连贯',
                label: '应用了简单的语句间连接成分，使上下文内容连贯'
            },
            {
                value: '能正确使用少量过渡词',
                label: '能正确使用少量过渡词'
            },
            {
                value: '文中很少使用过渡词和衔接词，层次不够清晰分明',
                label: '文中很少使用过渡词和衔接词，层次不够清晰分明'
            },
            {
                value: '行文流畅度欠缺，应增加文中衔接词的使用',
                label: '行文流畅度欠缺，应增加文中衔接词的使用'
            }
        ],
        [
            {
                value: '比较有效地使用了语句间的连接成分，使所完成的概要结构紧凑',
                label: '比较有效地使用了语句间的连接成分，使所完成的概要结构紧凑'
            },
            {
                value: '采用了适当的衔接手法，层次较清晰',
                label: '采用了适当的衔接手法，层次较清晰'
            },
            {
                value: '内容连贯性比较好，结构也比较紧凑',
                label: '内容连贯性比较好，结构也比较紧凑'
            },
            {
                value: '文章结构不错，使用了丰富的衔接词和过渡词',
                label: '文章结构不错，使用了丰富的衔接词和过渡词'
            }
        ],
        [
            {
                value: '有效地使用了语句间的连接成分，使所完成的概要结构紧凑',
                label: '有效地使用了语句间的连接成分，使所完成的概要结构紧凑'
            },
            {
                value: '正确有效地使用衔接词，文章要点组织简约有序',
                label: '正确有效地使用衔接词，文章要点组织简约有序'
            },
            {
                value: '文章逻辑性强，自然流畅，结构清晰，层次分明',
                label: '文章逻辑性强，自然流畅，结构清晰，层次分明'
            },
            {
                value: '上下文衔接自然，内容切题，表达清楚',
                label: '上下文衔接自然，内容切题，表达清楚'
            },
            {
                value: '逻辑结构严谨，分段布局合理，中心突出',
                label: '逻辑结构严谨，分段布局合理，中心突出'
            },
            {
                value: '各个要点间联系较好，表达流畅',
                label: '各个要点间联系较好，表达流畅'
            }
        ]
    ]
};
// 读后续写类型作文的评语
const continuation_comments = {
    // 第一维度
    word_evaluate: [
        [
            {
                value: '所写内容几乎没有完整的单词',
                label: '所写内容几乎没有完整的单词'
            },
            {
                value: '所用有效词汇太少，无法评价',
                label: '所用有效词汇太少，无法评价'
            },
            {
                value: '所写内容是汉语拼音',
                label: '所写内容是汉语拼音'
            }
        ],
        [
            {
                value: '同学字迹潦草，无法看清，需加强书写练习',
                label: '同学字迹潦草，无法看清，需加强书写练习'
            },
            {
                value: '同学用词太过单一，词汇量匮乏，要加强词汇量的积累',
                label: '同学用词太过单一，词汇量匮乏，要加强词汇量的积累'
            },
            {
                value: '同学词汇基础薄弱，词汇运用能力亟待加强',
                label: '同学词汇基础薄弱，词汇运用能力亟待加强'
            },
            {
                value: '用词错误和拼写错误较多，影响意思表达，几乎难以读懂',
                label: '用词错误和拼写错误较多，影响意思表达，几乎难以读懂'
            },
            {
                value: '标点使用错误过多，影响了意思的表达',
                label: '标点使用错误过多，影响了意思的表达'
            },
            {
                value: '通篇都是简单句，且出现了大量的语法错误',
                label: '通篇都是简单句，且出现了大量的语法错误'
            },
            {
                value: '语法基础薄弱，语法结构单调且错误极多',
                label: '语法基础薄弱，语法结构单调且错误极多'
            },
            {
                value: '意思表达含糊不清，大量中式表达',
                label: '意思表达含糊不清，大量中式表达'
            },
            {
                value: '整体表达混乱，正确句子比例极低',
                label: '整体表达混乱，正确句子比例极低'
            },
            {
                value: '存在大量的句法错误，时态混乱，语义表达不明',
                label: '存在大量的句法错误，时态混乱，语义表达不明'
            }
        ],
        [
            {
                value: '同学词汇运用能力有限，词汇较为匮乏，总体词汇使用不丰富',
                label: '同学词汇运用能力有限，词汇较为匮乏，总体词汇使用不丰富'
            },
            {
                value: '词汇使用不准确，错误较多，影响了对续写内容的理解',
                label: '词汇使用不准确，错误较多，影响了对续写内容的理解'
            },
            {
                value: '单词拼写错误过多，且大小写和标点错误较多',
                label: '单词拼写错误过多，且大小写和标点错误较多'
            },
            {
                value: '只有少量正确句子，意思表达不明确',
                label: '只有少量正确句子，意思表达不明确'
            },
            {
                value: '无句式变化，简单句的使用存在较多错误',
                label: '无句式变化，简单句的使用存在较多错误'
            },
            {
                value: '语义表达较单一，中式表达较明显',
                label: '语义表达较单一，中式表达较明显'
            }, {
                value: '部分简单句的表达中存在明显错误',
                label: '部分简单句的表达中存在明显错误'
            },
            {
                value: '句法基础不够扎实，部分句子的表达碎片化',
                label: '句法基础不够扎实，部分句子的表达碎片化'
            },
            {
                value: '部分句子结构混乱，存在语义含糊的问题',
                label: '部分句子结构混乱，存在语义含糊的问题'
            },
            {
                value: '语法基础不扎实，部分句子时态人称混乱',
                label: '语法基础不扎实，部分句子时态人称混乱'
            }
        ],
        [
            {
                value: '词汇表达较简单，希望同学可以积累高级词汇，加强词汇表达的多样性',
                label: '词汇表达较简单，希望同学可以积累高级词汇，加强词汇表达的多样性'
            },
            {
                value: '文章中使用了一些高级词汇，但有一些错误',
                label: '文章中使用了一些高级词汇，但有一些错误'
            },
            {
                value: '文章中有部分拼写、大小写和标点错误',
                label: '文章中有部分拼写、大小写和标点错误'
            },
            {
                value: '简单句偏多，从句比例偏低，可适当增加复杂句的使用让表达多样化',
                label: '简单句偏多，从句比例偏低，可适当增加复杂句的使用让表达多样化'
            },
            {
                value: '正确句子数量较多，部分复杂句的表达存在语法错误',
                label: '正确句子数量较多，部分复杂句的表达存在语法错误'
            },
            {
                value: '有一定的语法功底，但部分表达语义不明',
                label: '有一定的语法功底，但部分表达语义不明'
            },
            {
                value: '使用了简单的从句，但部分从句存在明显的错误',
                label: '使用了简单的从句，但部分从句存在明显的错误'
            },
            {
                value: '句式表达单一，语义较明确，但存在部分中式表达',
                label: '句式表达单一，语义较明确，但存在部分中式表达'
            },
            {
                value: '通篇都是简单句，可适当增加从句的使用为文章增加亮点',
                label: '通篇都是简单句，可适当增加从句的使用为文章增加亮点'
            },
            {
                value: '部分句子表达累赘，可适当精简结构使语义更清晰',
                label: '部分句子表达累赘，可适当精简结构使语义更清晰'
            }
        ],
        [
            {
                value: '基本词汇使用恰当灵活，但文中存在个别大小写及标点错误',
                label: '基本词汇使用恰当灵活，但文中存在个别大小写及标点错误'
            },
            {
                value: '文章词汇表达较丰富，能较好地使用中高档的词汇、短语等',
                label: '文章词汇表达较丰富，能较好地使用中高档的词汇、短语等'
            },
            {
                value: '同学词汇基础不错，但有少量拼写错误',
                label: '同学词汇基础不错，但有少量拼写错误'
            },
            {
                value: '词汇运用较自然流畅，拼写较准确',
                label: '词汇运用较自然流畅，拼写较准确'
            },
            {
                value: '词汇应用基本准确，有些错误主要是尝试使用较复杂的词汇和表达方式所致',
                label: '词汇应用基本准确，有些错误主要是尝试使用较复杂的词汇和表达方式所致'
            },
            {
                value: '句式变化较多样，个别句子存在小错误，但不影响理解',
                label: '句式变化较多样，个别句子存在小错误，但不影响理解'
            },
            {
                value: '句子错误很少，但个别复杂句使用不够熟练',
                label: '句子错误很少，但个别复杂句使用不够熟练'
            },
            {
                value: '句法比较规范，但长难句的使用偏少',
                label: '句法比较规范，但长难句的使用偏少'
            },
            {
                value: '句式变化较明显，部分简单从句转为复杂的长难句会让文章更出彩',
                label: '句式变化较明显，部分简单从句转为复杂的长难句会让文章更出彩'
            },
            {
                value: '有意识地使用了复杂句式，但表达中存在小错误',
                label: '有意识地使用了复杂句式，但表达中存在小错误'
            }
        ],
        [
            {
                value: '同学词汇基本功很好，高级词汇表达灵活熟练，单词拼写正确',
                label: '同学词汇基本功很好，高级词汇表达灵活熟练，单词拼写正确'
            },
            {
                value: '同学词汇表达灵活多变，固定搭配、句型使用恰当',
                label: '同学词汇表达灵活多变，固定搭配、句型使用恰当'
            },
            {
                value: '同学具备很强的词汇运用能力，同义词、反义词的使用和替换熟练',
                label: '同学具备很强的词汇运用能力，同义词、反义词的使用和替换熟练'
            },
            {
                value: '用词适切地道，单词拼写、大小写、标点符号使用正确',
                label: '用词适切地道，单词拼写、大小写、标点符号使用正确'
            },
            {
                value: '文中使用了很多积极正面的词汇，增强了文章的感情色彩和可读性',
                label: '文中使用了很多积极正面的词汇，增强了文章的感情色彩和可读性'
            },
            {
                value: '用词灵活适切，有个别语言错误，但完全不影响理解',
                label: '用词灵活适切，有个别语言错误，但完全不影响理解'
            },
            {
                value: '句子表达准确流畅，句法知识扎实，有效地使用了从句为文章增色',
                label: '句子表达准确流畅，句法知识扎实，有效地使用了从句为文章增色'
            },
            {
                value: '句式变化明显，长难句与简单句比例得当',
                label: '句式变化明显，长难句与简单句比例得当'
            },
            {
                value: '同学语法基础扎实，正确使用了复杂的语法结构',
                label: '同学语法基础扎实，正确使用了复杂的语法结构'
            },
            {
                value: '有意识地使用了谚语让表达更生动',
                label: '有意识地使用了谚语让表达更生动'
            },
            {
                value: '修辞的使用是文章的点睛之笔',
                label: '修辞的使用是文章的点睛之笔'
            }
        ]
    ],
    // 第二维度
    expression_evaluate: [
        [
            {
                value: '所写内容与题目要求无关',
                label: '所写内容与题目要求无关'
            },
            {
                value: '内容与要求无关或无法辨认',
                label: '内容与要求无关或无法辨认'
            },
            {
                value: '所传达的信息太少，无法评价',
                label: '所传达的信息太少，无法评价'
            }
        ],
        [
            {
                value: '续写句子太少，只写出若干与话题相关的句子',
                label: '续写句子太少，只写出若干与话题相关的句子'
            },
            {
                value: '只写出个别词语',
                label: '只写出个别词语'
            },
            {
                value: '内容太少，字数严重不足，无法评判',
                label: '内容太少，字数严重不足，无法评判'
            },
            {
                value: '内容与题目要求完全不相关',
                label: '内容与题目要求完全不相关'
            },
            {
                value: '内容全部抄自原文',
                label: '内容全部抄自原文'
            },
            {
                value: '为追求故事的离奇曲折而使内容完全没有逻辑性',
                label: '为追求故事的离奇曲折而使内容完全没有逻辑性'
            },
            {
                value: '内容与原文情境脱节，与给定文本情节逻辑、时空逻辑相矛盾',
                label: '内容与原文情境脱节，与给定文本情节逻辑、时空逻辑相矛盾'
            },
            {
                value: '内容完整性和逻辑性上有重大问题',
                label: '内容完整性和逻辑性上有重大问题'
            },
            {
                value: '内容偏离了正确的价值观',
                label: '内容偏离了正确的价值观'
            },
            {
                value: '没有使用短文中标有划线的关键词',
                label: '没有使用短文中标有划线的关键词'
            }
        ],
        [
            {
                value: '内容不够完整，字数不达标',
                label: '内容不够完整，字数不达标'
            },
            {
                value: '出现不必要的人或物，字数严重超标，废话过多',
                label: '出现不必要的人或物，字数严重超标，废话过多'
            },
            {
                value: '情节过多，故事拖沓',
                label: '情节过多，故事拖沓'
            },
            {
                value: '故事情节缺少逻辑性，线索中断',
                label: '故事情节缺少逻辑性，线索中断'
            },
            {
                value: '只有少量的续写内容与原文相关',
                label: '只有少量的续写内容与原文相关'
            },
            {
                value: '续写简略粗糙，人物缺乏鲜明的特征',
                label: '续写简略粗糙，人物缺乏鲜明的特征'
            },
            {
                value: '很少使用短文中标有划线的关键词',
                label: '很少使用短文中标有划线的关键词'
            }
        ],
        [
            {
                value: '内容基本完整，但缺少故事的结尾',
                label: '内容基本完整，但缺少故事的结尾'
            },
            {
                value: '字数达标，但部分内容与原文情节偏离',
                label: '字数达标，但部分内容与原文情节偏离'
            },
            {
                value: '续写内容的情节有一定的合理性，但部分情节偏离主题',
                label: '续写内容的情节有一定的合理性，但部分情节偏离主题'
            },
            {
                value: '内容与所给短文内容相关，但融洽度低',
                label: '内容与所给短文内容相关，但融洽度低'
            },
            {
                value: '故事主要角色符合原文，但添加了与原文脱节的细节',
                label: '故事主要角色符合原文，但添加了与原文脱节的细节'
            },
            {
                value: '使用了部分短文中标有划线的关键词',
                label: '使用了部分短文中标有划线的关键词'
            }
        ],
        [
            {
                value: '内容比较丰富完整，故事有主要的发展情节，但细节不够生动',
                label: '内容比较丰富完整，故事有主要的发展情节，但细节不够生动'
            },
            {
                value: '字数达标，情节较合理，有部分情节中断，但不影响故事主线',
                label: '字数达标，情节较合理，有部分情节中断，但不影响故事主线'
            },
            {
                value: '基本按照了故事发展的时间顺序来写，内容比较有逻辑性',
                label: '基本按照了故事发展的时间顺序来写，内容比较有逻辑性'
            },
            {
                value: '续写内容比较有逻辑性，与所给短文融洽度较高',
                label: '续写内容比较有逻辑性，与所给短文融洽度较高'
            },
            {
                value: '结尾有意识升华主题，但略显突兀',
                label: '结尾有意识升华主题，但略显突兀'
            },
            {
                value: '使用了大部分短文中标有划线的关键词',
                label: '使用了大部分短文中标有划线的关键词'
            }
        ],
        [
            {
                value: '内容丰富，故事完整，主次情节处理得当',
                label: '内容丰富，故事完整，主次情节处理得当'
            },
            {
                value: '基于生活，情节构思合情合理',
                label: '基于生活，情节构思合情合理'
            },
            {
                value: '逻辑性强，与所给短文融洽度高',
                label: '逻辑性强，与所给短文融洽度高'
            },
            {
                value: '细节描述生动，人物个性鲜明，形象丰满',
                label: '细节描述生动，人物个性鲜明，形象丰满'
            },
            {
                value: '续写故事中出现情节反转，出其不意却又在情理之中',
                label: '续写故事中出现情节反转，出其不意却又在情理之中'
            },
            {
                value: '内容体现了批判性思维',
                label: '内容体现了批判性思维'
            },
            {
                value: '故事主题升华了真善美等价值观',
                label: '故事主题升华了真善美等价值观'
            },
            {
                value: '使用了全部短文中标有划线的关键词',
                label: '使用了全部短文中标有划线的关键词'
            }
        ]
    ],
    // 第三维度
    structure_evaluate: [
        [
            {
                value: '所写内容与题目要求无关',
                label: '所写内容与题目要求无关'
            }
        ],
        [
            {
                value: '内容太少无法评判',
                label: '内容太少无法评判'
            },
            {
                value: '没有使用语句间过渡词和衔接词，建议增加衔接词汇的积累，并尝试运用',
                label: '没有使用语句间过渡词和衔接词，建议增加衔接词汇的积累，并尝试运用'
            },
            {
                value: '缺乏语句间的连接成分，全文内容不连贯',
                label: '缺乏语句间的连接成分，全文内容不连贯'
            },
            {
                value: '缺少过渡词和衔接词，上下文衔接不流畅',
                label: '缺少过渡词和衔接词，上下文衔接不流畅'
            },
            {
                value: '没有呼应所给出的段首语',
                label: '没有呼应所给出的段首语'
            },
            {
                value: '逻辑混乱，情节不连贯',
                label: '逻辑混乱，情节不连贯'
            },
            {
                value: '全文毫无连贯性可言，内容杂糅，结构混乱',
                label: '全文毫无连贯性可言，内容杂糅，结构混乱'
            }
        ],
        [
            {
                value: '较少使用语句间的连接成分，意义欠连贯',
                label: '较少使用语句间的连接成分，意义欠连贯'
            },
            {
                value: '全文有少量过渡词和衔接词，但存在重复使用现象',
                label: '全文有少量过渡词和衔接词，但存在重复使用现象'
            },
            {
                value: '文章结构不严谨，行文不流畅',
                label: '文章结构不严谨，行文不流畅'
            },
            {
                value: '文章不够连贯，影响对写作内容的理解',
                label: '文章不够连贯，影响对写作内容的理解'
            },
            {
                value: '续写短文时，有意识呼应所给出的段首语，但衔接度不高',
                label: '续写短文时，有意识呼应所给出的段首语，但衔接度不高'
            },
            {
                value: '故事内容线索混乱，缺少一定的条理性',
                label: '故事内容线索混乱，缺少一定的条理性'
            }
        ],
        [
            {
                value: '能正确使用少量过渡词，句子之间有一定的连贯性',
                label: '能正确使用少量过渡词，句子之间有一定的连贯性'
            },
            {
                value: '应用了简单的语句间连接成分，上下文内容基本连贯',
                label: '应用了简单的语句间连接成分，上下文内容基本连贯'
            },
            {
                value: '文中很少使用过渡词和衔接词，层次不够清晰分明',
                label: '文中很少使用过渡词和衔接词，层次不够清晰分明'
            },
            {
                value: '只与所给出的一个段首语呼应',
                label: '只与所给出的一个段首语呼应'
            },
            {
                value: '内容较完整，但部分情节不连贯',
                label: '内容较完整，但部分情节不连贯'
            },
            {
                value: '按照了时间顺序来写，有较清晰的故事线索，但流畅度欠缺',
                label: '按照了时间顺序来写，有较清晰的故事线索，但流畅度欠缺'
            }
        ],
        [
            {
                value: '比较有效地使用了语句间的连接成分，使所续写短文结构紧凑',
                label: '比较有效地使用了语句间的连接成分，使所续写短文结构紧凑'
            },
            {
                value: '文章结构不错，使用了较丰富的衔接词和过渡词',
                label: '文章结构不错，使用了较丰富的衔接词和过渡词'
            },
            {
                value: '内容连贯性比较好，结构也比较紧凑',
                label: '内容连贯性比较好，结构也比较紧凑'
            },
            {
                value: '内容与所给出的段首语衔接较为合理',
                label: '内容与所给出的段首语衔接较为合理'
            },
            {
                value: '内容较丰富，情节较连贯，但部分场景细节与原文脱离',
                label: '内容较丰富，情节较连贯，但部分场景细节与原文脱离'
            }
        ],
        [
            {
                value: '有效地使用了语句间、段落间的衔接成分，使所续写短文结构紧凑，意义连贯',
                label: '有效地使用了语句间、段落间的衔接成分，使所续写短文结构紧凑，意义连贯'
            },
            {
                value: '使用了丰富的衔接词和过渡词，语句连贯',
                label: '使用了丰富的衔接词和过渡词，语句连贯'
            },
            {
                value: '故事清晰，理清了时空逻辑、人物情感等逻辑主线，结构严谨',
                label: '故事清晰，理清了时空逻辑、人物情感等逻辑主线，结构严谨'
            },
            {
                value: '内容与所提供各段落开头语衔接合理，上下文衔接自然',
                label: '内容与所提供各段落开头语衔接合理，上下文衔接自然'
            },
            {
                value: '结尾句与原文首句相呼应，首尾圆和',
                label: '结尾句与原文首句相呼应，首尾圆和'
            },
            {
                value: '结尾句与主题句相呼应，突出了主题',
                label: '结尾句与主题句相呼应，突出了主题'
            }
        ]
    ]
};
// 应用文类型作文的评语
const practical_writing = {
    // 第一维度
    word_evaluate: [
        [
            {
                value: '所写内容几乎没有完整的单词',
                label: '所写内容几乎没有完整的单词'
            },
            {
                value: '所用有效词汇太少，无法评价',
                label: '所用有效词汇太少，无法评价'
            },
            {
                value: '所写内容是汉语拼音',
                label: '所写内容是汉语拼音'
            }
        ],
        [
            {
                value: '同学字迹潦草，无法看清，需加强书写练习',
                label: '同学字迹潦草，无法看清，需加强书写练习'
            },
            {
                value: '同学用词太过单一，词汇量匮乏，要加强词汇量的积累',
                label: '同学用词太过单一，词汇量匮乏，要加强词汇量的积累'
            },
            {
                value: '同学词汇基础薄弱，词汇运用能力亟待加强',
                label: '同学词汇基础薄弱，词汇运用能力亟待加强'
            },
            {
                value: '用词错误和拼写错误较多，影响意思表达，几乎难以读懂',
                label: '用词错误和拼写错误较多，影响意思表达，几乎难以读懂'
            },
            {
                value: '标点使用错误过多，影响了意思的表达',
                label: '标点使用错误过多，影响了意思的表达'
            },
            {
                value: '通篇都是简单句，且出现了大量的语法错误',
                label: '通篇都是简单句，且出现了大量的语法错误'
            },
            {
                value: '语法基础薄弱，语法结构单调且错误极多',
                label: '语法基础薄弱，语法结构单调且错误极多'
            },
            {
                value: '意思表达含糊不清，大量中式表达',
                label: '意思表达含糊不清，大量中式表达'
            },
            {
                value: '整体表达混乱，正确句子比例极低',
                label: '整体表达混乱，正确句子比例极低'
            },
            {
                value: '存在大量的句法错误，时态混乱，语义表达不明',
                label: '存在大量的句法错误，时态混乱，语义表达不明'
            }
        ],
        [
            {
                value: '同学词汇运用能力有限，词汇较为匮乏，总体词汇使用不丰富',
                label: '同学词汇运用能力有限，词汇较为匮乏，总体词汇使用不丰富'
            },
            {
                value: '词汇使用不准确，错误较多，影响了对文章内容的理解',
                label: '词汇使用不准确，错误较多，影响了对文章内容的理解'
            },
            {
                value: '单词拼写错误过多，且大小写和标点错误较多',
                label: '单词拼写错误过多，且大小写和标点错误较多'
            },
            {
                value: '只有少量正确句子，意思表达不明确',
                label: '只有少量正确句子，意思表达不明确'
            },
            {
                value: '无句式变化，简单句的使用存在较多错误',
                label: '无句式变化，简单句的使用存在较多错误'
            },
            {
                value: '语义表达较单一，中式表达较明显',
                label: '语义表达较单一，中式表达较明显'
            }, {
                value: '部分简单句的表达中存在明显错误',
                label: '部分简单句的表达中存在明显错误'
            },
            {
                value: '句法基础不够扎实，部分句子的表达碎片化',
                label: '句法基础不够扎实，部分句子的表达碎片化'
            },
            {
                value: '部分句子结构混乱，存在语义含糊的问题',
                label: '部分句子结构混乱，存在语义含糊的问题'
            },
            {
                value: '语法基础不扎实，部分句子时态人称混乱',
                label: '语法基础不扎实，部分句子时态人称混乱'
            }
        ],
        [
            {
                value: '词汇表达较简单，希望同学可以积累高级词汇，加强词汇表达的多样性',
                label: '词汇表达较简单，希望同学可以积累高级词汇，加强词汇表达的多样性'
            },
            {
                value: '文章中使用了一些高级词汇，但有一些错误',
                label: '文章中使用了一些高级词汇，但有一些错误'
            },
            {
                value: '文章中有部分拼写、大小写和标点错误',
                label: '文章中有部分拼写、大小写和标点错误'
            },
            {
                value: '简单句偏多，从句比例偏低，可适当增加复杂句的使用让表达多样化',
                label: '简单句偏多，从句比例偏低，可适当增加复杂句的使用让表达多样化'
            },
            {
                value: '简单句基本正确，但部分复杂句的表达存在语法错误',
                label: '简单句基本正确，但部分复杂句的表达存在语法错误'
            },
            {
                value: '有一定的语法功底，但部分表达语义不明',
                label: '有一定的语法功底，但部分表达语义不明'
            },
            {
                value: '使用了简单的从句，但部分从句存在明显的错误',
                label: '使用了简单的从句，但部分从句存在明显的错误'
            },
            {
                value: '句式表达单一，语义较明确，但存在部分中式表达',
                label: '句式表达单一，语义较明确，但存在部分中式表达'
            },
            {
                value: '通篇都是简单句，可适当增加从句的使用为文章增加亮点',
                label: '通篇都是简单句，可适当增加从句的使用为文章增加亮点'
            },
            {
                value: '部分句子表达累赘，可适当精简结构使语义更清晰',
                label: '部分句子表达累赘，可适当精简结构使语义更清晰'
            }
        ],
        [
            {
                value: '基本词汇使用恰当灵活，但文中存在个别大小写及标点错误',
                label: '基本词汇使用恰当灵活，但文中存在个别大小写及标点错误'
            },
            {
                value: '文章词汇表达较丰富，能较好地使用中高档的词汇、短语等',
                label: '文章词汇表达较丰富，能较好地使用中高档的词汇、短语等'
            },
            {
                value: '同学词汇基础不错，但有少量拼写错误',
                label: '同学词汇基础不错，但有少量拼写错误'
            },
            {
                value: '词汇运用较自然流畅，拼写较准确',
                label: '词汇运用较自然流畅，拼写较准确'
            },
            {
                value: '词汇应用基本准确，有些错误主要是尝试使用较复杂的词汇和表达方式所致',
                label: '词汇应用基本准确，有些错误主要是尝试使用较复杂的词汇和表达方式所致'
            },
            {
                value: '句式变化较多样，个别句子存在小错误，但不影响理解',
                label: '句式变化较多样，个别句子存在小错误，但不影响理解'
            },
            {
                value: '句子错误很少，但个别复杂句使用不够熟练',
                label: '句子错误很少，但个别复杂句使用不够熟练'
            },
            {
                value: '句法比较规范，但长难句的使用偏少',
                label: '句法比较规范，但长难句的使用偏少'
            },
            {
                value: '句式变化较明显，部分简单从句转为复杂的长难句会让文章更出彩',
                label: '句式变化较明显，部分简单从句转为复杂的长难句会让文章更出彩'
            },
            {
                value: '有意识地使用了复杂句式，但表达中存在小错误',
                label: '有意识地使用了复杂句式，但表达中存在小错误'
            }
        ],
        [
            {
                value: '同学词汇基本功很好，高级词汇表达灵活熟练，单词拼写正确',
                label: '同学词汇基本功很好，高级词汇表达灵活熟练，单词拼写正确'
            },
            {
                value: '同学词汇表达灵活多变，固定搭配、句型使用恰当',
                label: '同学词汇表达灵活多变，固定搭配、句型使用恰当'
            },
            {
                value: '同学具备很强的词汇运用能力，同义词、反义词的使用和替换熟练',
                label: '同学具备很强的词汇运用能力，同义词、反义词的使用和替换熟练'
            },
            {
                value: '用词适切地道，单词拼写、大小写、标点符号使用正确',
                label: '用词适切地道，单词拼写、大小写、标点符号使用正确'
            },
            {
                value: '文中使用了很多积极正面的词汇，增强了文章的感情色彩和可读性',
                label: '文中使用了很多积极正面的词汇，增强了文章的感情色彩和可读性'
            },
            {
                value: '用词灵活适切，语言准确，语气得当',
                label: '用词灵活适切，语言准确，语气得当'
            },
            {
                value: '句子表达准确流畅，句法知识扎实，有效地使用了从句为文章增色',
                label: '句子表达准确流畅，句法知识扎实，有效地使用了从句为文章增色'
            },
            {
                value: '句式变化明显，长难句与简单句比例得当',
                label: '句式变化明显，长难句与简单句比例得当'
            },
            {
                value: '同学语法基础扎实，正确使用了复杂的语法结构',
                label: '同学语法基础扎实，正确使用了复杂的语法结构'
            },
            {
                value: '有意识地使用了谚语让表达更生动',
                label: '有意识地使用了谚语让表达更生动'
            },
            {
                value: '修辞的使用是文章的点睛之笔',
                label: '修辞的使用是文章的点睛之笔'
            }
        ]
    ],
    // 第二维度
    expression_evaluate: [
        [
            {
                value: '所写内容与题目要求无关',
                label: '所写内容与题目要求无关'
            },
            {
                value: '内容与要求无关或无法辨认',
                label: '内容与要求无关或无法辨认'
            },
            {
                value: '所传达的信息太少，无法评价',
                label: '所传达的信息太少，无法评价'
            },
            {
                value: '写了一些完全不相关的内容，未能理解题目要求',
                label: '写了一些完全不相关的内容，未能理解题目要求'
            }
        ],
        [
            {
                value: '只写出个别词语',
                label: '只写出个别词语'
            },
            {
                value: '内容太少，字数严重不足，无法评判',
                label: '内容太少，字数严重不足，无法评判'
            },
            {
                value: '内容与题目要求基本不相关',
                label: '内容与题目要求基本不相关'
            },
            {
                value: '内容偏离了正确的价值观',
                label: '内容偏离了正确的价值观'
            },
            {
                value: '文章严重走题，没有包括所提供的信息内容',
                label: '文章严重走题，没有包括所提供的信息内容'
            }
        ],
        [
            {
                value: '内容不够完整，字数不达标',
                label: '内容不够完整，字数不达标'
            },
            {
                value: '要点不够全面，遗漏了题干中大部分要点',
                label: '要点不够全面，遗漏了题干中大部分要点'
            },
            {
                value: '文章内容没有条理性',
                label: '文章内容没有条理性'
            },
            {
                value: '文章杂糅，影响对写作内容的理解',
                label: '文章杂糅，影响对写作内容的理解'
            },
            {
                value: '没能准确地表达自己的观点',
                label: '没能准确地表达自己的观点'
            }
        ],
        [
            {
                value: '要点全面，但没有详略，如同记流水账',
                label: '要点全面，但没有详略，如同记流水账'
            },
            {
                value: '要点全面，但重点内容不够突出',
                label: '要点全面，但重点内容不够突出'
            },
            {
                value: '要点基本全面，但整体内容不够完整',
                label: '要点基本全面，但整体内容不够完整'
            },
            {
                value: '文中所举例子过于陈旧，不能打动人',
                label: '文中所举例子过于陈旧，不能打动人'
            },
            {
                value: '仅仅对文章的要点进行了翻译',
                label: '仅仅对文章的要点进行了翻译'
            },
            {
                value: '个别要点内容存在前后逻辑错误',
                label: '个别要点内容存在前后逻辑错误'
            }
        ],
        [
            {
                value: '理解准确，涵盖绝大部分写作要点',
                label: '理解准确，涵盖绝大部分写作要点'
            },
            {
                value: '对所给要点进行了巧妙的重组，自由发挥部分的内容可以再丰富些',
                label: '对所给要点进行了巧妙的重组，自由发挥部分的内容可以再丰富些'
            },
            {
                value: '可以比较清晰地、层次分明地表达出自己想表达的意思',
                label: '可以比较清晰地、层次分明地表达出自己想表达的意思'
            },
            {
                value: '论述缺少中心句，只陈述了理由',
                label: '论述缺少中心句，只陈述了理由'
            },
            {
                value: '对问题的分析很到位，但是解决措施写得较为笼统',
                label: '对问题的分析很到位，但是解决措施写得较为笼统'
            },
            {
                value: '对图片（表格）呈现的信息理解较为透彻',
                label: '对图片（表格）呈现的信息理解较为透彻'
            },
            {
                value: '论证比较清晰、有逻辑性，但需要多用更客观的句型',
                label: '论证比较清晰、有逻辑性，但需要多用更客观的句型'
            },
            {
                value: '观点陈述清晰直观，但是缺少一个有力的总结',
                label: '观点陈述清晰直观，但是缺少一个有力的总结'
            },
            {
                value: '准确地表达了个人的观点，但是论述不够深刻',
                label: '准确地表达了个人的观点，但是论述不够深刻'
            }
        ],
        [
            {
                value: '内容详略得当，覆盖了所有要点',
                label: '内容详略得当，覆盖了所有要点'
            },
            {
                value: '内容切题，表达清楚、完整',
                label: '内容切题，表达清楚、完整'
            },
            {
                value: '对所给要点进行了巧妙的重组，而不是直接翻译，并且进行了合理的发挥',
                label: '对所给要点进行了巧妙的重组，而不是直接翻译，并且进行了合理的发挥'
            },
            {
                value: '内容新颖，贴近社会现实',
                label: '内容新颖，贴近社会现实'
            },
            {
                value: '能够综合运用多种论证方法来论证论点，论述条理清晰',
                label: '能够综合运用多种论证方法来论证论点，论述条理清晰'
            },
            {
                value: '各个论点间联系较好，论证具有说服力',
                label: '各个论点间联系较好，论证具有说服力'
            }
        ]
    ],
    // 第三维度
    structure_evaluate: [
        [
            {
                value: '所写内容与题目要求无关',
                label: '所写内容与题目要求无关'
            }
        ],
        [
            {
                value: '内容太少无法评判',
                label: '内容太少无法评判'
            },
            {
                value: '没有使用语句间过渡词和衔接词，建议增加衔接词汇的积累，并尝试运用',
                label: '没有使用语句间过渡词和衔接词，建议增加衔接词汇的积累，并尝试运用'
            },
            {
                value: '缺乏语句间的连接成分，全文内容不连贯',
                label: '缺乏语句间的连接成分，全文内容不连贯'
            },
            {
                value: '缺少过渡词和衔接词，上下文衔接不流畅',
                label: '缺少过渡词和衔接词，上下文衔接不流畅'
            },
            {
                value: '全文毫无连贯性可言，内容杂糅，结构混乱',
                label: '全文毫无连贯性可言，内容杂糅，结构混乱'
            },
            {
                value: '没有遵循应用文的写作思路，逻辑结构混乱',
                label: '没有遵循应用文的写作思路，逻辑结构混乱'
            }
        ],
        [
            {
                value: '较少使用语句间的连接成分，意义欠连贯',
                label: '较少使用语句间的连接成分，意义欠连贯'
            },
            {
                value: '全文有少量过渡词和衔接词，但存在重复使用现象',
                label: '全文有少量过渡词和衔接词，但存在重复使用现象'
            },
            {
                value: '文章结构不严谨，行文不流畅',
                label: '文章结构不严谨，行文不流畅'
            },
            {
                value: '文章不够连贯，影响对写作内容的理解',
                label: '文章不够连贯，影响对写作内容的理解'
            },
            {
                value: '要点之间缺乏有效的过渡句，衔接比较突兀',
                label: '要点之间缺乏有效的过渡句，衔接比较突兀'
            },
            {
                value: '文章结构较混乱，部分要点前后不连贯',
                label: '文章结构较混乱，部分要点前后不连贯'
            }
        ],
        [
            {
                value: '能正确使用少量过渡词，句子之间有一定的连贯性',
                label: '能正确使用少量过渡词，句子之间有一定的连贯性'
            },
            {
                value: '应用了简单的语句间连接成分，上下文内容基本连贯',
                label: '应用了简单的语句间连接成分，上下文内容基本连贯'
            },
            {
                value: '文中很少使用过渡词和衔接词，层次不够清晰分明',
                label: '文中很少使用过渡词和衔接词，层次不够清晰分明'
            },
            {
                value: '文章写出了大致的框架，但部分要点之间衔接不连贯',
                label: '文章写出了大致的框架，但部分要点之间衔接不连贯'
            },
            {
                value: '文章整体结构不太明确，层次不分明',
                label: '文章整体结构不太明确，层次不分明'
            },
            {
                value: '分段布局不太合理，影响了文章的整体结构',
                label: '分段布局不太合理，影响了文章的整体结构'
            }
        ],
        [
            {
                value: '比较有效地使用了语句间的连接成分，使结构较紧凑',
                label: '比较有效地使用了语句间的连接成分，使结构较紧凑'
            },
            {
                value: '文章结构不错，使用了较丰富的衔接词和过渡词',
                label: '文章结构不错，使用了较丰富的衔接词和过渡词'
            },
            {
                value: '有意识地使用过渡句，使文章部分要点层次分明',
                label: '有意识地使用过渡句，使文章部分要点层次分明'
            },
            {
                value: '文章有一定的写作框架，层次较分明，结构也比较紧凑',
                label: '文章有一定的写作框架，层次较分明，结构也比较紧凑'
            }
        ],
        [
            {
                value: '使用了丰富的衔接词和过渡词，语句连贯，使全文结构紧凑',
                label: '使用了丰富的衔接词和过渡词，语句连贯，使全文结构紧凑'
            },
            {
                value: '叙事条理清晰，逻辑结构严谨',
                label: '叙事条理清晰，逻辑结构严谨'
            },
            {
                value: '分段布局合理，中心突出',
                label: '分段布局合理，中心突出'
            },
            {
                value: '段落之间的过渡句，使用恰当，使要点有逻辑地过渡、结合',
                label: '段落之间的过渡句，使用恰当，使要点有逻辑地过渡、结合'
            },
            {
                value: '遵循了应用文写作框架，结构清晰，思路严谨',
                label: '遵循了应用文写作框架，结构清晰，思路严谨'
            }
        ]
    ]
}

// 返回不同年级分数区间的回调
function manage(value){
    if (value === 7 || value === 8) {
        return seven_star_score;
    } else if (value === 9) {
        return nine_star_score;
    } else {
        return high_school_score;
    }
};
// 返回不同年级评语列表的回调
function getEvaluate(grade,type) {
    if (grade > 9 && type) {
        if (type === 12702) {
            return summary_writing_comments;
        } else if (type === 12703) {
            return continuation_comments
        } else {
            return practical_writing;
        }
    } else {
        return basic_comments;
    }
}
export default {
    // seven_star_score,
    // nine_star_score,
    // structure,
    getEvaluate,
    manage
}


